import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgLayoutMinimal = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 9H1.5V15H7.5V9Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14.25H22.5M12 9.75H22.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 21.75H22.5M1.5 2.25H22.5",
			stroke: "currentColor",
			strokeOpacity: .4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgKgLayoutMinimal;
